import { normalizeForSearch, searchMatchPre } from './searchMatch';

export function filtreleZayiKayitlar(rows, { q = '', tip = '' } = {}) {
  let out = rows || [];
  if (tip === 'recete') out = out.filter(r => r.recipe_id);
  else if (tip === 'malzeme') out = out.filter(r => !r.recipe_id);
  if (q && q.trim()) {
    const lower = normalizeForSearch(q);
    out = out.filter(r => searchMatchPre(`${r.malzeme_ad || ''} ${r.neden || ''} ${r.neden_kategori_ad || ''}`, lower));
  }
  return out;
}

export function siralaZayiKayitlar(rows, key, dir = 'desc') {
  const sign = dir === 'asc' ? 1 : -1;
  const num = new Set(['miktar']);
  return [...(rows || [])].sort((a, b) => {
    let av = a[key], bv = b[key];
    if (num.has(key)) { av = Number(av) || 0; bv = Number(bv) || 0; return (av - bv) * sign; }
    av = (av ?? '').toString(); bv = (bv ?? '').toString();
    return av.localeCompare(bv, 'tr') * sign;
  });
}

export function zayiKayitlarToCSV(rows) {
  const headers = ['Tarih', 'Lokasyon', 'Malzeme/Reçete', 'Miktar', 'Birim', 'Neden', 'Not'];
  const esc = (v) => {
    const s = (v ?? '').toString();
    return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [headers.join(';')];
  for (const r of rows || []) {
    lines.push([r.tarih, r.lokasyon_ad, r.malzeme_ad, r.miktar, r.malzeme_birim,
      r.neden_kategori_ad, r.neden].map(esc).join(';'));
  }
  return '﻿' + lines.join('\n');
}
